import React, {useEffect, useState, useCallback} from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import { apiClient } from '../../components/api/ApiClient';
import persian from "react-date-object/calendars/persian";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import DateObject from "react-date-object";
import ProductsTable from "./productTable";
import AddProductModal from "./addProductModal";
import JalaliDatePicker from '../../components/common/JalaliDatePicker';
import Modal from 'react-bootstrap/Modal';
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian_cal from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

function ReturnedInvoicesPage(mode) {
    const returnMode = mode?.mode || mode
    const {id, target} = useParams();
    const [invoice, setInvoice] = useState();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [inputErrors, setInputErrors] = useState({});
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [userConfigure, setUserConfigure] = useState(null);

    const [invoiceAlgo, setInvoiceAlgo] = useState();
    const [paymentType, setPaymentType] = useState();
    const [cashPayment, setCashPayment] = useState();
    const [creditPayment, setCreditPayment] = useState();
    const [lastInvoiceDate, setLastInvoiceDate] = useState();
    const [invoiceNum, setInvoiceNum] = useState(null)
    const [finalDate, setFinalDate] = useState(null);
    const [finalFaDate, setFinalFaDate] = useState(null);

    const [productItems, setProductItems] = useState([]);
    const [sumPriceBeforeSale, setSumPriceBeforeSale] = useState();
    const [sumSalePrice, setSumSalePrice] = useState();
    const [sumPriceAfterSale, setSumPriceAfterSale] = useState();
    const [sumTaxPrice, setSumTaxPrice] = useState();
    const [sumOtherTax, setSumOtherTax] = useState();
    const [sumTotalPrice, setSumTotalPrice] = useState();
    const [sumWeight, setSumWeight] = useState();
    const [sumRialValue, setSumRialValue] = useState();
    const [sumCurrencyValue, setSumCurrencyValue] = useState();
    const [vppSum, setVppSum] = useState();

    const [showAddProducts, setShowAddProducts] = useState(false);
    const handleCloseAddProducts = () => setShowAddProducts(false);
    const [toast, setToast] = useState({ show: false, message: '', type: 'info' });
    
    useEffect(() => {
        if (toast.show) {
            const timer = setTimeout(() => setToast({ ...toast, show: false }), 5000);
            return () => clearTimeout(timer);
        }
    }, [toast.show]);

    const showToast = (message, type = 'info') => setToast({ show: true, message, type });

    const handleOpenProductModalForEdit = (product, index) => {
        setSelectedProduct({product: product, index: index,});
        setShowAddProducts(true);
    };
    // const handleUpdateProduct = (updatedProduct) => {
    //     const {index} = updatedProduct;
    //     setProductItems(prevProducts =>
    //         prevProducts.map((product, i) =>
    //             i === index ? updatedProduct : product
    //         )
    //     );
    // };
    const handleUpdateProduct = (updatedProduct) => {
        const {index} = updatedProduct;

        setProductItems(prevProducts => {
            const prevProduct = prevProducts[index];
            const prevCount = prevProduct.amount;
            const newCount = updatedProduct.amount;
            if (newCount > prevCount) {
                showToast('تعداد جدید نباید از تعداد قبلی بیشتر باشد !', 'error')
                return prevProducts;
            }
            return prevProducts.map((product, i) =>
                i === index ? updatedProduct : product
            );
        });
    };

    function toValidDateObject(input) {
        if (input instanceof DateObject && input.isValid) return input;
        if (typeof input === 'object' && input !== null && typeof input.year === 'number') {
            try {
                const d = new DateObject(input);
                if (d.isValid) return d;
            } catch (e) { console.error(e); }
        }
        if (typeof input === 'string') {
            const d = new DateObject({ date: new Date(input), calendar: gregorian });
            if (d.isValid) return d;
        }
        return null;
    }

    const handleDeleteProduct = (id) => {
        setProductItems((prevProducts) =>
            prevProducts.filter((_, idx) => idx !== id)
        );
    };
    const handleDateChange = (value, fieldName) => {
        const finalValue = toValidDateObject(value);
        if (finalValue?.isValid) {
            const formattedValue = finalValue.format("HH:mm YYYY/MM/DD");
            const faDate = new DateObject({
                date: finalValue,
                calendar: persian,
            });
            const geDate = faDate.convert(gregorian, gregorian_en).format("HH:mm YYYY/MM/DD")
            if (fieldName === "final") {
                setInputErrors((prev) => ({...prev, finalDate: ""}));
                const now = new DateObject({calendar: gregorian, locale: gregorian_en});
                const geDateObj = new DateObject({
                    date: geDate,
                    format: "HH:mm YYYY/MM/DD",
                    calendar: gregorian,
                    locale: gregorian_en
                });
                if (geDateObj > now) {
                    setInputErrors((prev) => ({
                        ...prev,
                        finalDate: 'تاریخ انتخاب شده نباید از زمان حال بزرگتر باشد!',
                    }));
                    return;
                }
                if (geDateObj < lastInvoiceDate) {
                    setInputErrors((prev) => ({
                        ...prev,
                        finalDate: 'تاریخ انتخاب شده نباید از تاریخ اخرین صورتحساب کوچکتر باشد!',
                    }));
                    return;
                }
                setFinalFaDate(faDate)
                setFinalDate(geDate);
            }
        }
    };
    const formatFinalDate = (value) => {
        const finalValue = toValidDateObject(value);
        if (finalValue?.isValid) {
            const faDate = new DateObject({
                date: finalValue,
                calendar: persian,
            }).format("HH:mm YYYY/MM/DD")
            return faDate;
        }
        return null;
    };
    const fetchUserConfig = async (typeOfInvoice, algoOfInvoice) => {
        try {
            const response = await apiClient('/user-preferences/api/invoice-config/', {
                params: {
                    typeOfInvoice,
                    algoOfInvoice
                }
            });
            let fieldsArray = response?.fields_config || response;
            if (!Array.isArray(fieldsArray) && fieldsArray && typeof fieldsArray === 'object') {
                fieldsArray = Object.entries(fieldsArray).map(
                    ([name, cfg]) => ({ name, ...cfg })
                );
            }
            if (Array.isArray(fieldsArray)) {
                const configObject = Object.fromEntries(
                    fieldsArray.map(({ name, ...rest }) => [name, rest])
                );
                setUserConfigure(configObject);
            }
        } catch (e) {
            console.error("Error fetching invoice config:", e);
        }
    };

    const getInvoice = async () => {
        try {
            setLoading(true)
            const response = await apiClient('/invoice/api/', {
                data: {invoiceId: id},
                method: "POST",
            })
            const invoice = response.data
            if (invoice) {
                const formattedFinalDate = formatFinalDate(invoice.finalDate);
                setInvoice({
                    ...invoice,
                    formattedFinalDate,
                });
                setInvoiceAlgo(invoice.invoiceAlgo)
                fetchUserConfig(invoice.invoiceType, invoice.invoiceAlgo)
                setPaymentType(invoice.paymentType)
                if (invoice.productItems.length > 0 && returnMode === 'create') {
                    setProductItems(invoice.productItems)
                    setSumPriceBeforeSale(invoice.sumPriceBeforeSale)
                    setSumSalePrice(invoice.sumSalePrice)
                    setSumPriceAfterSale(invoice.sumPriceAfterSale)
                    setSumTaxPrice(invoice.sumTaxPrice)
                    setSumOtherTax(invoice.sumOtherTax)
                    setSumTotalPrice(invoice.sumTotalPrice)
                    setSumWeight(invoice.sumWeight)
                    setSumRialValue(invoice.sumRialValue)
                    setSumCurrencyValue(invoice.sumCurrencyValue)
                    setVppSum(invoice.vppSum)
                }
            }
        } catch (error) {
            console.log("ERROR ON RODD", error);
        } finally {
            setLoading(false)
        }
    }
    const getInvoiceItem = async () => {
        try {
            const response = await apiClient('/invoice/api/new-invoice/');
            if (returnMode == 'create') {
                setInvoiceNum(response.num);
            }
            const lastDate = toValidDateObject(response.lastDate);
            setLastInvoiceDate(lastDate)
        } catch (err) {
            console.error('Failed to fetch data:', err);
        }
    }
    useEffect(() => {
        const priceBeforeSale = productItems?.reduce((acc, item) => acc + parseFloat(item.priceBeforeSale || 0), 0) || null;
        const salePrice = productItems?.reduce((acc, item) => acc + parseFloat(item.salePrice || 0), 0) || null;
        const priceAfterSale = productItems?.reduce((acc, item) => acc + parseFloat(item.priceAfterSale || 0), 0) || null;
        const taxPrice = productItems?.reduce((acc, item) => acc + parseFloat(item.taxPrice || 0), 0) || null;
        const otherTax = productItems?.reduce((acc, item) => acc + parseFloat(item.otherTaxP + item.otherLegalP || 0), 0) || 0;
        const totalPrice = productItems?.reduce((acc, item) => acc + parseFloat(item.totalPrice || 0), 0) || null;
        const weight = productItems?.reduce((acc, item) => acc + parseFloat(item.weight || 0), 0) || null;
        const rialValue = productItems?.reduce((acc, item) => acc + parseFloat(item.rialValue || 0), 0) || null;
        const currencyValue = productItems?.reduce((acc, item) => acc + parseFloat(item.currencyValue || 0), 0) || null;
        const vppValue = productItems?.reduce((acc, item) => acc + parseFloat(item.vpp || 0), 0) || null;
        setSumPriceBeforeSale(Math.trunc(priceBeforeSale));
        setSumSalePrice(Math.trunc(salePrice));
        setSumPriceAfterSale(Math.trunc(priceAfterSale));
        setSumTaxPrice(Math.trunc(taxPrice));
        setSumOtherTax(Math.trunc(otherTax));
        setSumTotalPrice(Math.trunc(totalPrice));
        setSumWeight(weight);
        setSumRialValue(Math.trunc(rialValue));
        setSumCurrencyValue(Math.trunc(currencyValue));
        setVppSum(Math.trunc(vppValue));
        if (paymentType === 'cash') {
            setCashPayment(Math.trunc(totalPrice - otherTax - taxPrice))
        } else if (paymentType === 'credit') {
            setCreditPayment(Math.trunc(totalPrice - otherTax - taxPrice))
        }
    }, [productItems]);
    const validateInvoiceFields = () => {
        const invoiceData = {
            invoiceNum,
            finalDate,
        };

        const requiredFields = ['invoiceNum', 'finalDate'];

        let errors = {};
        requiredFields.forEach((field) => {
            if (
                invoiceData[field] === null ||
                (typeof invoiceData[field] === 'string' && invoiceData[field].trim() === "")
            ) {
                errors[field] = "این فیلد الزامی است";
            }
        });

        setInputErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const buildInvoicePayload = () => ({
        invoiceNum,
        finalDate,
        productItems,
        sumPriceBeforeSale,
        sumSalePrice,
        sumPriceAfterSale,
        sumTaxPrice,
        sumOtherTax,
        sumTotalPrice,
    });
    const sendInvoice = async () => {
        if (!validateInvoiceFields()) {
            showToast('فیلد های الزامی را پر کنید !', 'error')
            return;
        }
        const payload = buildInvoicePayload();
        try {
            const response = await apiClient('/invoice/api/invoice-returned/', {
                data: {id, ...payload},
                method: "POST",
            })
            showToast('صورتحساب شما با موفقیت ثبت شد.', 'success')

            navigate('/invoices/list/')
        } catch (e) {
            if (e.message) {
                if (e.message === 'referenced') {
                    showToast('این صورتحساب قبلاً مرجع فاکتور دیگری قرار گرفته است.', 'error')
                } else {
                    showToast(e.message, 'error');
                }
            } else {
                showToast('خطایی در ثبت صورتحساب رخ داد.', 'error');
            }
        }
    }
    const updateInvoice = async () => {
        if (!validateInvoiceFields()) {
            showToast('فیلد های الزامی را پر کنید !', 'error')
            return;
        }
        const payload = buildInvoicePayload();
        try {
            const response = await apiClient('/invoice/api/invoice-returned/', {
                data: {target, ...payload},
                method: "PATCH",
            })
            showToast('صورتحساب شما با موفقیت ثبت شد.', 'success')
            navigate('/invoices/list/')
        } catch (e) {
            if (e.message) {
                if (e.message === 'referenced') {
                    showToast('این صورتحساب قبلاً مرجع فاکتور دیگری قرار گرفته است.', 'error')
                } else {
                    showToast(e.message, 'error');
                }
            } else {
                showToast('خطایی در ثبت صورتحساب رخ داد.', 'error');
            }
        }
    }
    const getTargetInvoice = async () => {
        try {
            const response = await apiClient('/invoice/api/invoice-returned/', {
                data: {
                    target: target
                },
                method: "GET",
            });
            const data = response || response.data || response.data.data
            if (data) {
                setInvoiceNum(data.invoiceNum);
                setInvoiceAlgo(data.invoiceAlgo);
                fetchUserConfig(data.invoiceType, data.invoiceAlgo);
                const date = handleDateChange(data.finalDate, 'final');
                if (data.productItems.length > 0) {
                    setProductItems(data.productItems)
                    setSumPriceBeforeSale(data.sumPriceBeforeSale)
                    setSumSalePrice(data.sumSalePrice)
                    setSumPriceAfterSale(data.sumPriceAfterSale)
                    setSumTaxPrice(data.sumTaxPrice)
                    setSumOtherTax(data.sumOtherTax)
                    setSumTotalPrice(data.sumTotalPrice)
                    setSumWeight(data.sumWeight)
                    setSumRialValue(data.sumRialValue)
                    setSumCurrencyValue(data.sumCurrencyValue)
                    setVppSum(data.vppSum)
                }
            }
        } catch (err) {
            console.error(err);
        }
    }
    useEffect(() => {
        getInvoice()
        getInvoiceItem();
        if (returnMode != 'create' && target) {
            getTargetInvoice()
        }
    }, []);
    return (
        <div className="card">
            {toast.show && (
                <div aria-live="polite" aria-atomic="true" className="position-fixed w-100 p-3" style={{ zIndex: 1060, top: 0, right: 0 }}>
                    <div className="toast-container position-absolute p-3" style={{ top: 0, left: 0 }}>
                        <div className="toast show" role="alert" aria-live="assertive" aria-atomic="true">
                            <div className="toast-header" style={{ direction: 'rtl' }}>
                                <img src="/assets/images/redesigned.png" className="rounded ms-2" alt="..." width="20" />
                                <strong className="me-auto ms-2">پیام سیستم</strong>
                                <button type="button" className="btn-close" onClick={() => setToast({ ...toast, show: false })}></button>
                            </div>
                            <div className="toast-body">{toast.message}</div>
                        </div>
                    </div>
                </div>
            )}

            <div className="card-header d-flex justify-content-between">

                <h5>صدور صورتحساب اصلاحی</h5>

                <button className="btn btn-outline-secondary" onClick={() => navigate("/invoices/list/")}>خروج</button>

            </div >

            <div className=" card-body">
                <div className='mt-2 mb-4 table-responsive'>
                    <div className="d-flex mb-4 justify-item-center">
                        <h6 className="mb-0 ms-5">صورتحساب مورد نظر</h6>
                        <div className="bg-black flex-grow-1 m-auto me-5 header-hr"></div>
                    </div>

                    {loading ? (
                        <div className="text-center p-5 bg-secondary-subtle border-7">
                            <p className='fs-2'>در حال بارگذاری داده‌ها...</p>
                        </div>
                    ) : invoice ? (
                        <table className='table table-hover'>
                            <thead>
                                <tr>
                                    <th className='text-center'>شماره صورتحساب</th>
                                    <th className='text-center'>تاریخ و زمان صدور</th>
                                    <th className='text-center'>مبلغ فروش</th>
                                    <th className='text-center'>مبلغ ارزش افزوده</th>
                                    {['3', '2'].includes(invoice.buyerType) && <th className='text-center'>شماره اقتصادی خریدار</th>}
                                    {invoice.buyerType === '1' && <th className="text-center">شناسنامه / کد ملی خریدار</th>}
                                    {invoice.buyerType === '4' && <th className="text-center">کد فراگیر اتباع غیر ایرانی خریدار</th>}<th className='text-center'>عملیات</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className='text-center'>{invoice.invoiceNum}</td>
                                    <td className='text-center'>{invoice.formattedFinalDate}</td>
                                    <td className='text-center'>{invoice.sumTotalPrice}</td>
                                    <td className='text-center'>{invoice.sumTaxPrice}</td>
                                    {['3', '2'].includes(invoice.buyerType) && <td className='text-center'>{invoice.buyerEconomicNum}</td>}
                                    {['1', '4'].includes(invoice.buyerType) && <td className='text-center'>{invoice.buyerId}</td>}
                                    <td>
                                        <div className="d-flex flex-column align-items-center">
                                            <button className='btn btn-sm btn-link mt-2' onClick={() => navigate(`/invoice/view/${id}`)}>مشاهده کامل</button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    ) : (
                        <div className='text-center p-5 bg-secondary-subtle border-7'>
                            <p className='fs-2'>هیچ صورتحسابی موجود نیست.</p>
                        </div>
                    )}
                </div>

                <div className="row">
                    <div className="d-flex mb-4 mt-5 justify-item-center border-top pt-3">
                        <h6 className="mb-0 ms-5">اطلاعات تکمیلی</h6>
                        <div className="bg-black flex-grow-1 m-auto me-5 header-hr"></div>
                    </div>

                    <div className="col-md-6">

                        <label className="form-label">شماره صورتحساب <span className="text-danger">*</span></label>

                        <input

                            className={`form-control ${inputErrors.invoiceNum ? "is-invalid" : ""}`}

                            value={invoiceNum || ""}

                            onChange={e => setInvoiceNum(e.target.value)}
                            disabled={true}

                        />

                        {inputErrors.invoiceNum && <div className="invalid-feedback">{inputErrors.invoiceNum}</div>}

                    </div>

                    <div className="col-md-6">

                        <label className='form-label'>تاریخ و زمان صدور صورتحساب <span className="text-danger">*</span></label>

                        <DatePicker
                                format="HH:mm YYYY/MM/DD"
                                inputClass="form-control"
                                style={{ display: 'block' }}
                                inputId="finalDate"
                                fieldName="finalDate"
                                calendar={persian_cal}
                                locale={persian_fa}
                                value={finalFaDate}
                                onChange={(value) => handleDateChange(value, "final")}
                                plugins={[
                                    <TimePicker position="bottom"/>
                                ]}
                                onClear={() => {
                                    setFinalFaDate(null);
                                    setFinalDate(null);
                                }}
                                containerStyle={{
                                        display: "block",
                                        width: "100%"
                                    }}
                            />

                    </div>

                </div >
                <div className="d-flex mb-4 mt-5 justify-item-center border-top pt-3">
                    <h6 className="mb-0 ms-5">مشخصات کالا/خدمت</h6>
                    <div className="bg-black flex-grow-1 m-auto me-5 header-hr"></div>
                </div>
                {productItems.length === 0 ? (
                    <div className="alert alert-warning text-end mb-4">هیچ کالا/خدمتی انتخاب نشده است.</div>
                ) : (
                    <ProductsTable
                        data={productItems}
                        onRowClick={handleOpenProductModalForEdit}
                        onRowDelete={handleDeleteProduct}
                    />
                )}
                
                <div className="rtl d-flex mb-4 justify-item-center">
                    <h6 className="mb-0 ms-5">مجموع هزینه ها</h6>
                    <div className="bg-black flex-grow-1 m-auto me-5 header-hr"></div>
                </div>
                <div className="d-flex flex-wrap gap-4 mb-4 px-5">
                    {sumWeight > 0 && (
                        <div className="d-flex align-items-center gap-2 rtl">
                            <span className="text-muted">مجموع وزن خالص:</span>
                            <h6 className="mb-0 fw-bold">{sumWeight}</h6>
                        </div>
                    )}
                    {sumPriceBeforeSale > 0 && (
                        <div className="d-flex align-items-center gap-2 rtl">
                            <span className="text-muted">مبلغ قبل از تخفیف:</span>
                            <h6 className="mb-0 fw-bold">{sumPriceBeforeSale}</h6>
                            <small className="text-muted">ریال</small>
                        </div>
                    )}
                    {sumSalePrice > 0 && (
                        <div className="d-flex align-items-center gap-2 rtl">
                            <span className="text-muted">تخفیفات:</span>
                            <h6 className="mb-0 fw-bold text-danger">{sumSalePrice}</h6>
                            <small className="text-muted">ریال</small>
                        </div>
                    )}
                    {sumPriceAfterSale > 0 && (
                        <div className="d-flex align-items-center gap-2 rtl">
                            <span className="text-muted">مبلغ پس از تخفیف:</span>
                            <h6 className="mb-0 fw-bold">{sumPriceAfterSale}</h6>
                            <small className="text-muted">ریال</small>
                        </div>
                    )}{sumTaxPrice > 0 && (
                        <div className="d-flex align-items-center gap-2 rtl">
                            <span className="text-muted">مالیات ارزش افزوده:</span>
                            <h6 className="mb-0 fw-bold">{sumTaxPrice}</h6>
                            <small className="text-muted">ریال</small>
                        </div>
                    )}
                    {sumOtherTax > 0 && (
                        <div className="d-flex align-items-center gap-2 rtl">
                            <span className="text-muted">سایر مالیات و عوارض:</span>
                            <h6 className="mb-0 fw-bold">{sumOtherTax}</h6>
                            <small className="text-muted">ریال</small>
                        </div>
                    )}{sumCurrencyValue > 0 && (
                        <div className="d-flex align-items-center gap-2 rtl">
                            <span className="text-muted">ارزش ارزی:</span>
                            <h6 className="mb-0 fw-bold">{sumCurrencyValue}</h6>
                            <small className="text-muted">ریال</small>
                        </div>
                    )}
                    {sumRialValue > 0 && (
                        <div className="d-flex align-items-center gap-2 rtl">
                            <span className="text-muted">ارزش ریالی:</span>
                            <h6 className="mb-0 fw-bold">{sumRialValue}</h6>
                            <small className="text-muted">ریال</small>
                        </div>
                    )}
                    {vppSum > 0 && (
                        <div className="d-flex align-items-center gap-2 rtl">
                            <span className="text-muted">سهم مالیات از پرداخت:</span>
                            <h6 className="mb-0 fw-bold">{vppSum}</h6>
                            <small className="text-muted">ریال</small>
                        </div>
                    )}
                    {sumTotalPrice > 0 && (
                        <div className="d-flex align-items-center gap-2 rtl">
                            <span className="fw-bold fs-6">مجموع کل صورتحساب:</span>
                            <h5 className="mb-0 fw-bold text-success">{sumTotalPrice}</h5>
                            <small className="text-muted">ریال</small>
                        </div>
                    )}
                </div>
            </div>

            <div className="card-footer d-flex justify-content-end gap-2">
                <button className="button text-white bg-success border-0 py-2 px-4" disabled={loading} onClick={returnMode === "edit" ? updateInvoice : sendInvoice}>
                    ثبت
                </button>
                <button className="button text-white bg-danger border-0 py-2 px-4" onClick={() => navigate("/invoices/list/")}>
                    انصراف
                </button>
            </div>

            <Modal show={showAddProducts} onHide={handleCloseAddProducts} size="lg" centered scrollable>
                <Modal.Header>
                    <Modal.Title>ویرایش کالا / خدمت</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AddProductModal
                        product={selectedProduct}
                        onUpdate={handleUpdateProduct}
                        onClose={handleCloseAddProducts}
                        onAdd={handleCloseAddProducts}
                        invoiceAlgo={invoiceAlgo}
                        userConfigure={userConfigure}
                    />
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default ReturnedInvoicesPage;